import { monospaceFontFamily } from "src/providers/theme";
import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    ip: {
        fontFamily: monospaceFontFamily,
    },
    simDivider: {
        margin: `${theme.spacing(1)} 0`,
    },
    simSlotHeader: {
        fontWeight: "bold",
        marginBottom: theme.spacing(0.5),
    },
    simGrid: {
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        columnGap: theme.spacing(4),
    },
    tableWrapper: {
        marginTop: theme.spacing(4),
    },
    twoColumnRow: {
        display: "flex",
        width: "100%",
    },
    twoColumnLeft: {
        width: "50%",
        paddingRight: theme.spacing(1),
    },
    twoColumnRight: {
        width: "50%",
        paddingLeft: theme.spacing(1),
    },
    columnHeader: {
        fontSize: 14,
        fontWeight: 600,
    },
}));
